import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Typography } from 'antd';
import { trainingProjectFormFields, trainingProjectTaskTypeValues, taskTypeSchemas } from '../../misc/constants';
import { TrainingProjectTaskType } from '../../types';
import { TrainingProjectsStore } from '../../stores';
import { TrainingProjectJsonEditor } from '..';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectJsonSchemas: React.FC<Props> = ({ store }) => {
    return (
        <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
                const taskType = getFieldValue(trainingProjectFormFields.taskType) as
                    | TrainingProjectTaskType
                    | undefined;

                if (taskType === trainingProjectTaskTypeValues.JsonExtraction) {
                    const fieldLabel = 'Output Schema';
                    const initialValue =
                        store.editableTrainingProject?.jsonSchemas?.[taskTypeSchemas[taskType].outputSchema];

                    return (
                        <>
                            <Typography.Title level={5}>Json Schemas</Typography.Title>
                            <Form.Item
                                label={fieldLabel}
                                name={[trainingProjectFormFields.jsonSchemas, taskTypeSchemas[taskType].outputSchema]}
                                initialValue={initialValue}
                                rules={[{ required: true, message: 'Please provide output schema.' }]}
                            >
                                <TrainingProjectJsonEditor fieldLabel={fieldLabel} lastSavedValue={initialValue} />
                            </Form.Item>
                        </>
                    );
                }

                return null;
            }}
        </Form.Item>
    );
};

export default observer(TrainingProjectJsonSchemas);
